import { render, staticRenderFns } from "./user-modal.vue?vue&type=template&id=448756dc&scoped=true"
import script from "./user-modal.vue?vue&type=script&lang=js"
export * from "./user-modal.vue?vue&type=script&lang=js"
import style0 from "./user-modal.vue?vue&type=style&index=0&id=448756dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448756dc",
  null
  
)

export default component.exports